<template>
  <div class="page-container" v-loading="pageLoading">
    <div class="header">
      <div class="title">我的云管家</div>
    </div>
    <template v-if="!pageLoading">
      <template v-if="hasResister">
        <div class="account-cards">
          <div class="account-card">
            <div class="card-title">
              <div class="title-text">
                资产总额
                <el-tooltip content="资产总额=可用余额+冻结金额，表示客户在云管家账户的总资产余额。" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="card-amount">¥ {{ totalBalance }}</div>
          </div>
          <div class="account-card">
            <div class="card-title">
              <div class="title-text">可用余额</div>
              <el-button type="text" class="security-setting-btn" @click="openSecuritySetting">安全设置</el-button>
              <el-button type="text" class="security-setting-btn" @click="openAccountInfo">分账银行账户信息</el-button>
            </div>
            <div class="card-amount">¥ {{ accountAmt }}</div>
            <div class="card-btns">
              <span class="btn" @click="handleWithdrawal" :loading="withdrawalLoading">提现</span>
              <span class="btn" @click="handleDivide">分账</span>
            </div>
          </div>
          <div class="account-card">
            <div class="card-title">
              <div class="title-text">
                冻结金额
                <el-tooltip content="客户在发起提现、分账后，还在处理中的交易，账务金额会临时冻结，待银行实际完成结算后，总资产余额会进行扣减，如银行结算失败的，冻结金额则释放至可用余额。" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="card-amount">¥ {{ freezeBalance }}</div>
            <!-- copilot begin -->
            <div class="in-progress-counts">
              <div class="count-row">
                <div class="count-item withdrawal" @click="goToWithdrawalRecords">
                  <div class="count-content">
                    <span class="count-label">提现在途笔数</span>
                    <span class="count-value">{{ withdrawCount }}</span>
                  </div>
                </div>
                <div class="count-item split-account" @click="goToDivideAccounts">
                  <div class="count-content">
                    <span class="count-label">分账在途笔数</span>
                    <span class="count-value">{{ splitAccountCount }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- copilot end -->
        </div>
        <div class="search-form">
          <el-form class="search-form-content" inline :model="form" label-width="100px" label-position="right">
            <el-row>
              <el-col :span="6">
                <el-form-item label="流水单号" size="small">
                  <el-input v-model="form.flowId" placeholder="请输入流水单号" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="类型" size="small">
                  <el-select v-model="form.businessType" clearable>
                    <el-option v-for="(label, value) in businessTypeMap" :key="value" :value="value" :label="label" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="动账日期" size="small">
                  <el-date-picker
                    v-model="dateTimeRange"
                    type="datetimerange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    align="right"
                    size="small"
                    clearable />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <div style="width: 100%;text-align: right;">
                  <el-button size="small" type="primary" @click="handleFormSearch" class="bs-btn">查询</el-button>
                  <el-button size="small" @click="handleFormReset" class="bs-btn2">重置</el-button>
                  <el-button size="small" type="primary" @click="exportTable" class="bs-btn" :loading="exportLoading">导出</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="table-container">
          <div class="table-wrapper">
            <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading" max-height="100%">
              <el-table-column prop="flowId" label="流水单号" align="center" min-width="250px" />
              <el-table-column prop="updateDate" label="动账时间" align="center" min-width="150px" />
              <el-table-column prop="amountStr" label="金额" align="center" min-width="150px" />
              <el-table-column prop="balanceStr" label="结余" align="center" min-width="150px" />
              <el-table-column prop="fundsTypeDesc" label="资金类型" align="center" min-width="150px" />
              <el-table-column prop="businessType" label="类型" align="center" min-width="100px">
                <template slot-scope="{row: {businessType}}">{{ businessTypeMap[businessType] }}</template>
              </el-table-column>
              <el-table-column label="操作" align="center" min-width="80px">
                <template slot-scope="scope">
                  <el-button type="text" @click="openDetail(scope.$index, scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-content">
            <el-pagination
              v-if="table.totalCount > 0"
              :page-size="table.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="table.totalCount"
              :current-page="table.pageNo"
              @current-change="onChangeCurrentPage" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="no-resister">
          <div>云管家[分账]产品</div>
          <p>云管家(分账)产品，通过满足商家将收款资金按照一定的周期、比例、金额等规则分给合作方的场景诉求，以实现商家资金管理更灵活，更方便，更快捷。</p>
          <el-button size="small" type="primary" class="bs-btn" @click="handleOpen" :loading="openLoading">立即开通</el-button>
        </div>
      </template>
    </template>
    <el-dialog title="提现" :visible.sync="showWithdrawalDialog" width="500px" center @close="handleCloseWithdrawal">
      <el-form ref="withdrawalDialogFormRef" :model="withdrawalForm" :rules="withdrawalRulesComputed" style="width: 100%;margin-top: 20px;" size="small" label-width="140px">
        <el-form-item label="提现金额" prop="withdrawalAmount">
          <el-input v-model="withdrawalForm.withdrawalAmount" :placeholder="`最多可提金额${divide(withdrawalForm.canAmount, 100).toFixed(2)}元`" type="number" :maxLength="13" clearable />
        </el-form-item>
        <el-form-item label="到账金额">{{ subtract(withdrawalForm.withdrawalAmount, divide(withdrawalForm.fee, 100)).toFixed(2) }}</el-form-item>
        <el-form-item label="提现手续费" prop="fee">{{ divide(withdrawalForm.fee, 100).toFixed(2) }}</el-form-item>
        <el-form-item label="到账银行" prop="bankName">{{ withdrawalForm.bankName }}</el-form-item>
        <el-form-item label="开户名称" prop="bankHolder">{{ withdrawalForm.bankHolder }}</el-form-item>
        <el-form-item label="银行卡号" prop="bankCardNo">{{ withdrawalForm.bankCardNo }}</el-form-item>
        <el-form-item label="商户管理密码" prop="password" v-if="passwordVerifyEnabled">
          <el-input v-model="withdrawalForm.password" :type="withdrawalForm.pwdType || 'password'" placeholder="请输入商户管理密码">
            <svg-icon slot="suffix" class="icon" :iconClass="withdrawalForm.pwdIcon || 'hide-pwd'" @click="handleWithdrawalPasswordIconClick" />
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button class="bs-btn2" @click="handleCloseWithdrawal">关闭</el-button>
        <el-button type="primary" class="bs-btn" @click="handleConfirmWithdrawal" :loading="withdrawalConfirmLoading">提交申请</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分账" :visible.sync="showDivideDialog" width="800px" center @close="handleCloseDivideDialog">
      <template v-if="active === 0">
        <p>当前支持分账金额剩余：{{ accountAmt }}（元）</p>
        <el-form :model="divideForm" style="width: 100%;margin-top: 20px;" size="small" label-width="140px">
          <el-form-item label="请上传分账文件" prop="file">
            <el-upload :file-list="divideForm.file" class="avatar-uploader" :auto-upload="false" action="" accept=".xlsx,.xls" :limit="1" :on-change="beforeAvatarUpload">
              <el-button type="primary" class="bs-btn">请选择文件</el-button>
            </el-upload>
            <p>单次最大分账数量为100条</p>
            <el-button type="text" @click="handleDownDivideFile">下载分账计划模板</el-button>
            <template v-if="divideForm.checkTotalStatus === 1">
              <p style="color: red;">
                分账计划数据异常请核实
                <el-button type="text" @click="handleExportSaPlanException">下载分账计划异常原因</el-button>
              </p>
            </template>
          </el-form-item>
        </el-form>
      </template>
      <template v-else>
        <p style="margin-bottom: 16px;">
          分账计划共计{{ divideForm.totalCount || 0 }}条，
          接收方{{ divideForm.totalReceiveCount || 0 }}个，
          分账金额：{{ divide(divideForm.totalAmount, 100).toFixed(2) || 0.00 }}元
        </p>
        <el-table :data="divideTable.data" style="width: 100%;" border v-loading="divideTable.loading">
          <el-table-column prop="receiveMerchantId" label="接收方商户编号" align="center" min-width="150px" />
          <el-table-column prop="receiveMerchantName" label="接收方商户名称" align="center" min-width="150px" />
          <el-table-column prop="splitAmount" label="分账金额" align="center" min-width="150px">
            <template slot-scope="{row: {splitAmount}}">{{ divide(splitAmount, 100).toFixed(2) || 0.00 }}</template>
          </el-table-column>
          <el-table-column prop="realAmount" label="实际到账金额" align="center" min-width="150px">
            <template slot-scope="{row: {realAmount}}">{{ divide(realAmount, 100).toFixed(2) || 0.00 }}</template>
          </el-table-column>
        </el-table>
        <div class="pagination-content">
          <el-pagination
            v-if="divideTable.totalCount > 0"
            :page-size="divideTable.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="divideTable.totalCount"
            :current-page="divideTable.pageNo"
            @current-change="onChangeCurrentDialogPage" />
        </div>
        <el-form :model="divideForm" style="margin-top: 20px;" size="small" label-width="100px">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="divideForm.remark" :rows="3" :maxlength="100" resize="none" type="textarea" placeholder="分账说明，给接收方的留言" />
          </el-form-item>
          <el-form-item label="商户管理密码" prop="password" v-if="passwordVerifyEnabled">
            <el-input v-model="divideForm.password" :type="divideForm.pwdType || 'password'" placeholder="请输入商户管理密码" style="width: 60%;">
              <svg-icon slot="suffix" class="icon" :iconClass="divideForm.pwdIcon || 'hide-pwd'" @click="handleDividePasswordIconClick" />
            </el-input>
            <p class="tip-text" style=" margin-top: 5px; font-size: 12px;color: red;">提示: 如不需要可在安全设置中关闭。</p>
          </el-form-item>
        </el-form>
        <el-checkbox v-model="check">以上分账信息我已确认无误，同意按照该计划进行分账。</el-checkbox>
      </template>
      <div slot="footer">
        <el-button class="bs-btn2" @click="handleCloseDivideDialog">关闭</el-button>
        <el-button type="primary" class="bs-btn" @click="handleConfirmTipDialog" v-if="divideForm.checkTotalStatus === 0 && active === 0 || active === 1" :loading="divideConfirmLoading">
          {{ active === 0 ? '下一步' : '提交申请' }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="showDetailDialog" width="500px" center>
      <div class="detail-form-container">
        <el-form label-width="100px" label-position="left" class="detail-form">
          <el-form-item label="余额变动单号">
            <span id="flowId">{{ detailForm.flowId || '-' }}</span>
            <copy-btn v-if="detailForm.flowId" id="#flowId" />
          </el-form-item>
          <el-form-item label="变动时间">{{ detailForm.createTime || '-' }}</el-form-item>
          <el-form-item label="交易类型">{{ businessTypeMap[detailForm.businessType] || '-' }}</el-form-item>
          <el-form-item label="收支类型">{{ detailForm.operateType === 0 ? '出账' : '入账' }}</el-form-item>
          <el-form-item label="变动金额">{{ detailForm.amount || '-' }}</el-form-item>
          <el-form-item label="变动前金额">{{ detailForm.beforeBalance || '-' }}</el-form-item>
          <el-form-item label="变动后金额">{{ detailForm.balance || '-' }}</el-form-item>

          <el-form-item label="原业务单据" class="detail-section-title"></el-form-item>
          <el-form-item label="业务类型">{{ businessTypeMap[oriBusinessDocument.businessType] || '-' }}</el-form-item>
          <el-form-item label="原业务流水号">
            <span id="oriBusinessDocumentBusinessSerialNo">{{ oriBusinessDocument.businessSerialNo || '-' }}</span>
            <copy-btn v-if="oriBusinessDocument.businessSerialNo" id="#oriBusinessDocumentBusinessSerialNo" />
          </el-form-item>
          <template v-if="detailForm.businessType === '15'">
            <el-form-item label="关联充值单据" class="detail-section-title"></el-form-item>
            <el-form-item label="业务类型">{{ businessTypeMap[rechargeDocument.businessType] || '-' }}</el-form-item>
            <el-form-item label="原业务流水号">
              <span id="rechargeDocumentBusinessSerialNo">{{ rechargeDocument.businessSerialNo || '-' }}</span>
              <copy-btn v-if="rechargeDocument.businessSerialNo" id="#rechargeDocumentBusinessSerialNo" />
            </el-form-item>
            <el-form-item label="动账流水单号">
              <span id="rechargeDocumentFlowId">{{ rechargeDocument.flowId || '-' }}</span>
              <copy-btn v-if="rechargeDocument.flowId" id="#rechargeDocumentFlowId" />
            </el-form-item>
          </template>
          <template v-if="detailForm.businessType === '5'">
            <el-form-item label="分账账户信息" class="detail-section-title"></el-form-item>
            <el-form-item label="分账接收方">
              <span id="receiveMerchantId">{{ detailForm.receiveMerchantName }}(ID:{{ detailForm.receiveMerchantId }})</span>
              <copy-btn v-if="detailForm.receiveMerchantId" id="#receiveMerchantId" />
            </el-form-item>
            <el-form-item label="银行卡号">
              <span id="bankAccountNo">{{ detailForm.bankAccountNo }}({{ detailForm.bankName }})</span>
              <copy-btn v-if="detailForm.bankAccountNo" id="#bankAccountNo" />
            </el-form-item>
            <el-form-item label="分账场景">{{ splitAccountSceneMap[detailForm.splitAccountScene] || '-' }}</el-form-item>
            <el-form-item label="分账明细" class="detail-section-title"></el-form-item>
            <el-form-item label="分账金额">{{ detailForm.splitAmount || '-' }}</el-form-item>
            <el-form-item label="分账手续费">{{ detailForm.fee || '-' }}</el-form-item>
            <el-form-item label="备注">{{ detailForm.remark || '-' }}</el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDetailDialog = false">取消</el-button>
        <el-button class="bs-btn" type="primary" @click="showDetailDialog = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="安全设置" :visible.sync="showSecurityDialog" width="400px" center>
      <div class="security-dialog">
        <div class="security-item">
          <div class="security-info">
            <span class="security-label">密码验证:</span>
          </div>
          <el-switch v-model="passwordVerifyEnabled" @change="handlePasswordVerifyChange" active-color="#13ce66" inactive-color="#909399" :loading="switchLoading"></el-switch>
          <span>{{ passwordVerifyEnabled ? "已开启" : "未开启" }}</span>
        </div>
        <div class="security-item">
          <span>说明：开启后商家提现、分账时进行密码校验，忘记密码的可通过商家APP个人中心进行修改</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="分账银行账户信息" :visible.sync="showBankDialog" width="500px" center>
      <el-form label-suffix="：" label-width="150px">
        <el-form-item label="开户名称">{{ bankAccountInfo.openBankAccountName }}</el-form-item>
        <el-form-item label="收单结算账户号">{{ bankAccountInfo.bankAccountNo }}</el-form-item>
        <el-form-item label="外部入金账户号">{{ bankAccountInfo.bankAccountNoOuter }}</el-form-item>
        <el-form-item label="开户行">{{ bankAccountInfo.bankName }}</el-form-item>
        <el-form-item label="联行号">{{ bankAccountInfo.unionpayCode }}</el-form-item>
      </el-form>
      <div style="font-size: 12px;line-height: 20px;color: #999;">注：为便于您更高效地管理资金，分账功能开通后，已为您开立两个专属账户</div>
      <div style="font-size: 12px;line-height: 20px;color: #999;">收单结算账户‌：用于日常收单资金结算。</div>
      <div style="font-size: 12px;line-height: 20px;color: #999;">外部入金账户‌：用于接收外部渠道转入资金。</div>
      <div style="font-size: 12px;line-height: 20px;color: #999;">请您妥善保管账户信息，谨防诈骗，如有疑问，请联系客户经理！</div>
    </el-dialog>
    <el-dialog title="操作验证" :visible.sync="showVerifyDialog" width="500px" center append-to-body @close="handleVerifyDialogClose">
      <div class="verify-dialog">
        <div class="verify-tip">验证码已发送至<span class="phone-mask">{{ mobileMask }}</span></div>
        <div class="verify-input">
          <span class="verify-label">验证手机号:</span>
          <el-input v-model="verifyCode" placeholder="请输入手机验证码" class="verify-code-input">
            <el-button slot="append" @click="sendVerifyCode" :disabled="countdown > 0">
              {{ countdown > 0 ? `${countdown}s后重新获取` : '获取验证码' }}
            </el-button>
          </el-input>
        </div>
        <div class="verify-actions">
          <el-button type="primary" class="bs-btn" @click="confirmVerify" :loading="verifyLoading">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import CopyBtn from '@/components/CopyBtn/copy-btn.vue';
import SvgIcon from '@/components/SvgIcon/index.vue';
import {
  accountSearchSubBalance,
  applySplitAccount,
  downloadSaPlan,
  executeSplitAccount,
  exportBalanceFlow,
  exportSaPlanException,
  getSplitToken,
  importSaPlan,
  queryPageSplitSerial,
  queryWithdrawalInfo,
  searchBalanceFlow,
  stateQuery,
  submitWithdrawalInfo,
  searchBalanceFlowDetail,
  getSecurityConfigStatus,
  sendSecurityVerifyCode,
  checkSecurityVerifyCode,
  updateSecurityStatus,
  queryCashierCloudBankAccountInfo,
} from '@/api/cloud-manage';
import { debounce, sToFixed } from "@/utils/index";
import { divide, multiply, subtract } from '../../../utils/math';


const FORMAT = 'yyyy-MM-DD HH:mm:ss';
const start = moment().subtract(365, 'days').startOf('d').format(FORMAT);
const end = moment().endOf('d').format(FORMAT);

export default {
  name: "open",
  components: {
    CopyBtn,
    SvgIcon,
  },
  data() {
    return {
      pageLoading: false,
      openLoading: false,
      hasResister: false,
      managerState: false,
      accountAmt: 0,
      totalBalance: 0,
      freezeBalance: 0,
      withdrawCount: 0, // 提现在途笔数
      splitAccountCount: 0, // 分账在途笔数
      businessTypeMap: {
        1: '充值',
        2: '充值撤销',
        3: '消费',
        4: '消费撤销',
        5: '转账',
        6: '转账撤销',
        7: '提现',
        8: '提现撤销',
        15: '外部入金服务费扣除',
      },
      splitAccountSceneMap: {
        1001: 'B2C电商平台',
        1002: 'O2O电商服务平台',
        1003: '共享租赁',
        1004: '知识付费/内容分成',
        1005: '多方合作营销',
        1006: '供应链/连锁经营',
      },
      dateTimeRange: [start, end],
      form: {
        flowId: '',
        businessType: '',
      },
      table: {
        loading: false,
        data: [],
        pageNo: 1,
        totalCount: 0,
        pageSize: 5,
      },
      pickerOptions: {
        disabledDate(time) {
          // 日期只能选最近一年的时间
          const oneYearAgo = moment().subtract(365, 'days').valueOf();
          return moment(time).valueOf() < oneYearAgo;
        },
      },
      exportLoading: false,
      withdrawalLoading: false,
      withdrawalConfirmLoading: false,
      showWithdrawalDialog: false,
      withdrawalForm: {
        withdrawalAmount: '',
        canAmount: '',
        actualAmount: '',
        fee: '',
        bankHolder: '',
        bankName: '',
        bankCardNo: '',
        password: '',
        pwdType: 'password',
        pwdIcon: 'hide-pwd',
      },
      showDivideDialog: false,
      divideConfirmLoading: false,
      active: 0,
      divideForm: {
        file: [],
        remark: '',
        bankMobile: '',
        totalAmount: null,
        totalReceiveCount: null,
        totalCount: null,
        verifyCode: '',
        splitBatchNo: '',
        checkTotalStatus: '',
        password: '',
        pwdType: 'password',
        pwdIcon: 'hide-pwd',
      },
      divideTable: {
        loading: false,
        data: [],
        pageNo: 1,
        totalCount: 0,
        pageSize: 10,
      },
      check: false,
      showDetailDialog: false,
      detailForm: {},
      showSecurityDialog: false,
      showBankDialog: false,
      bankAccountInfo: {
        openBankAccountName: '',
        bankAccountNo: '',
        bankAccountNoOuter: '',
        bankName: '',
        unionpayCode: '',
      },
      passwordVerifyEnabled: false,
      showVerifyDialog: false,
      verifyCode: '',
      countdown: 0,
      verifyLoading: false,
      switchLoading: false,
      mobilePhone: '',
      mobileMask: '',
    };
  },
  computed: {
    loginInfo() {
      return JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
    },
    // 避免 detailForm 中嵌套对象不存在导致模板直接报错
    oriBusinessDocument() {
      return (this.detailForm && this.detailForm.oriBusinessDocument) ? this.detailForm.oriBusinessDocument : {};
    },
    rechargeDocument() {
      return (this.detailForm && this.detailForm.rechargeDocument) ? this.detailForm.rechargeDocument : {};
    },
    exportTable() {
      return debounce(this.exportTableFunc, 500, true);
    },
    withdrawalRulesComputed() {
      const baseRules = {
        withdrawalAmount: [{ required: true, message: "请输入提现金额", trigger: ['blur', 'change'] }, { validator: this.validateAmount }],
      };
      // 只有在密码验证启用时才添加密码验证
      if (this.passwordVerifyEnabled) {
        baseRules.password = [{ required: true, message: "请输入商户管理密码", trigger: ['blur', 'change'] }];
      }
      return baseRules;
    },
  },
  mounted() {
    this.initPage();
  },
  methods: {
    divide,
    subtract,
    async initPage() {
      this.pageLoading = true;
      const { data: { data } } = await stateQuery().finally(() => {
        this.pageLoading = false;
      });
      this.hasResister = data.saOpenStatus === 2;
      this.managerState = data.managerState === 0; // 0-正常、1-销户、2-冻结
      if (this.hasResister) {
        try {
          const { merchantId } = this.loginInfo;
          const { data: { data: { status } } } = await getSecurityConfigStatus({ merchantId });
          this.passwordVerifyEnabled = status === 1;
        } catch (err) {
          console.error('获取密码验证状态失败', err);
          this.passwordVerifyEnabled = false;
        }
        this.handleFormSearch();
        this.queryAccountSearchSubBalance();
      }
    },
    handleOpen() {
      const { merchantId } = this.loginInfo;
      this.openLoading = true;
      getSplitToken({ merchantId, jumpUrl: '' }).then(({ data: { data: { url } } }) => {
        window.open(url, '_blank');
      }).finally(() => {
        this.openLoading = false;
      });
    },
    queryAccountSearchSubBalance() {
      accountSearchSubBalance({}).then(({ data: { data } }) => {
        this.accountAmt = data.availBalance ? sToFixed(divide(data.availBalance, 100)) : 0;
        this.totalBalance = data.totalBalance ? sToFixed(divide(data.totalBalance, 100)) : 0;
        this.freezeBalance = data.freezeBalance ? sToFixed(divide(data.freezeBalance, 100)) : 0;
        this.withdrawCount = data.withdrawCount || 0;
        this.splitAccountCount = data.splitAccountCount || 0;
      });
    },
    openDetail(index, row) {
      searchBalanceFlowDetail({ flowId: row.flowId }).then(({ data: { data } }) => {
        this.detailForm = {
          ...data,
          amount: data.amount ? sToFixed(divide(data.amount, 100)) : 0,
          beforeBalance: data.beforeBalance ? sToFixed(divide(data.beforeBalance, 100)) : 0,
          balance: data.balance ? sToFixed(divide(data.balance, 100)) : 0,
          splitAmount: data.splitAmount ? sToFixed(divide(data.splitAmount, 100)) : 0,
          fee: data.fee ? sToFixed(divide(data.fee, 100)) : 0,
        };
        this.showDetailDialog = true;
      });
    },
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.form = {
        flowId: '',
        businessType: '',
      };
      this.dateTimeRange = [start, end];
      this.handleFormSearch();
    },
    async queryTableData() {
      const { pageNo, pageSize } = this.table;
      const [updateTimeStartStr, updateTimeEndStr] = this.dateTimeRange || [];
      const params = {
        ...this.form,
        pageNo,
        pageSize,
        updateTimeStartStr,
        updateTimeEndStr,
      };
      this.table.loading = true;
      const { data: { data: { list, totalCount } } } = await searchBalanceFlow(params).finally(() => {
        this.table.loading = false;
      });
      this.table.data = list;
      this.table.totalCount = totalCount;
    },
    exportTableFunc() {
      const [updateTimeStartStr, updateTimeEndStr] = this.dateTimeRange || [];
      const params = {
        ...this.form,
        updateTimeStartStr,
        updateTimeEndStr,
      };
      this.exportLoading = true;
      exportBalanceFlow(params).then(({ data: { code } }) => {
        if (code === '0') {
          this.$message.success('导出成功，请到下载中心下载报表文件！');
        }
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentDialogPage(pageNo) {
      this.divideTable.pageNo = pageNo;
      this.queryDialogTableData();
    },
    queryDialogTableData() {
      const FORMAT = 'yyyy-MM-DD HH:mm:ss';
      const startTime = moment().subtract(90, 'days').startOf('d').format(FORMAT);
      const endTime = moment().endOf('d').format(FORMAT);
      const { pageNo, pageSize } = this.divideTable;
      const { splitBatchNo } = this.divideForm;
      const statuses = -1;
      const params = {
        pageNo,
        pageSize,
        startTime,
        endTime,
        splitBatchNo,
        statuses,
      };
      this.divideTable.loading = true;
      queryPageSplitSerial(params).then(({
        data: {
          data: {
            list,
            totalCount,
            totalReceiveCount,
            totalAmount,
          },
        },
      }) => {
        this.divideTable.data = list;
        this.divideTable.totalCount = totalCount;
        this.divideForm.totalCount = totalCount;
        this.divideForm.totalReceiveCount = totalReceiveCount;
        this.divideForm.totalAmount = totalAmount;
        this.divideTable.loading = false;
      });
    },
    handleCloseDivideDialog() {
      this.showDivideDialog = false;
      this.divideForm = {
        file: [],
        remark: '',
        bankMobile: '',
        amount: '',
        numSize: '',
        planSize: '',
        verifyCode: '',
        splitBatchNo: '',
        checkTotalStatus: '',
        password: '',
        pwdType: 'password',
        pwdIcon: 'hide-pwd',
      };
      this.active = 0;
      this.check = false;
    },
    handleConfirmTipDialog() {
      if (this.active === 0) {
        this.divideConfirmLoading = true;
        // 厦门银行需要调用提交申请接口，苏商银行直接请求回流即可
        // applySplitAccount({ splitBatchNo }).then(({
        //   data: {
        //     code,
        //     data: {
        //       splitStatus, bankMobile, amount, numSize, planSize,
        //     },
        //   },
        // }) => {
        //   if (code === '0' && splitStatus !== 2) {
        //     this.active = 1;
        //     this.divideForm = {
        //       ...this.divideForm, bankMobile, amount, numSize, planSize,
        //     };
        //     this.divideTable.pageNo = 1;
        //     this.queryDialogTableData();
        //   } else {
        //     this.$message.warning('分账申请失败');
        //   }
        // }).finally(() => {
        //   this.divideConfirmLoading = false;
        // });
        this.active = 1;
        this.divideTable.pageNo = 1;
        this.queryDialogTableData();
        this.divideConfirmLoading = false;
      } else if (this.active === 1 && !this.check) {
        this.$message.warning('请勾选分账信息确认');
      } else {
        this.divideConfirmLoading = true;
        const { splitBatchNo, password, remark } = this.divideForm;
        const params = { splitBatchNo, remark };
        if (this.passwordVerifyEnabled && password) {
          params.verifyCode = this.$md5(password);
        }
        executeSplitAccount(params).then(({ data: { code, data } }) => {
          if (code === '0') {
            this.$message.success('分账确认成功，请在分账记录查看分账处理结果');
            this.handleFormSearch();
            this.queryAccountSearchSubBalance();
            this.handleCloseDivideDialog();
          }
        }).finally(() => {
          this.divideConfirmLoading = false;
        });
      }
    },
    beforeAvatarUpload(files) {
      const formData = new FormData();
      formData.append('file', files.raw);
      importSaPlan(formData).then(({ data: { code, data: { splitBatchNo, checkTotalStatus } } }) => {
        this.divideForm.splitBatchNo = splitBatchNo;
        this.divideForm.checkTotalStatus = checkTotalStatus;
        this.$message.success('文件上传成功');
      }).catch(() => {
        this.divideForm.file = [];
      });
    },
    handleDownDivideFile() {
      downloadSaPlan();
    },
    handleExportSaPlanException() {
      const { splitBatchNo } = this.divideForm;
      exportSaPlanException({ splitBatchNo });
    },
    handleWithdrawal() {
      this.withdrawalLoading = true;
      const { merchantId } = this.loginInfo;
      queryWithdrawalInfo({ merchantId }).then(({ data: { data } }) => {
        this.withdrawalForm = {
          ...data,
          withdrawalAmount: '',
          password: '',
          pwdType: 'password',
          pwdIcon: 'hide-pwd',
        };
        this.showWithdrawalDialog = true;
      }).finally(() => {
        this.withdrawalLoading = false;
      });
    },
    handleDivide() {
      if (this.managerState) {
        this.showDivideDialog = true;
      } else {
        this.$message.warning('云管家账户异常不允许分账');
      }
    },
    handleCloseWithdrawal() {
      this.showWithdrawalDialog = false;
      this.withdrawalForm = {
        withdrawalAmount: '',
        canAmount: '',
        actualAmount: '',
        fee: '',
        bankHolder: '',
        bankName: '',
        bankCardNo: '',
        password: '',
        pwdType: 'password',
        pwdIcon: 'hide-pwd',
      };
    },
    handleConfirmWithdrawal() {
      this.$refs.withdrawalDialogFormRef.validate((valid) => {
        if (valid) {
          const { merchantId } = this.loginInfo;
          const { withdrawalAmount, password } = this.withdrawalForm;
          const params = {
            merchantId,
            withdrawalAmount: multiply(withdrawalAmount, 100),
          };
          if (this.passwordVerifyEnabled && password) {
            params.businessVerifyCode = this.$md5(password);
          }
          this.withdrawalConfirmLoading = true;
          submitWithdrawalInfo(params).then(({ data: { code, data: { withdrawalStatus } } }) => {
            if (code === '0' && withdrawalStatus === 1) {
              this.$message.success('提现申请提交成功');
              this.handleCloseWithdrawal();
              this.handleFormSearch();
              this.queryAccountSearchSubBalance();
            }
          }).finally(() => {
            this.withdrawalConfirmLoading = false;
          });
        }
      });
    },
    openAccountInfo() {
      queryCashierCloudBankAccountInfo({}).then(({ data: { data, code } }) => {
        if (code === '0') {
          this.showBankDialog = true;
          this.bankAccountInfo = data;
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    openSecuritySetting() {
      const { merchantId } = this.loginInfo;
      getSecurityConfigStatus({ merchantId }).then(({ data: { data: { status }, error_code: errorCode } }) => {
        if (errorCode === 0) {
          this.passwordVerifyEnabled = status === 1;
          this.showSecurityDialog = true;
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    handlePasswordVerifyChange(val) {
      const { merchantId } = this.loginInfo;
      this.switchLoading = true;
      if (val) {
        updateSecurityStatus({
          merchantId,
          status: 1,
        }).then(({ data: { error_code: code } }) => {
          if (code === 0) {
            this.$message.success('安全验证已开启！');
          } else {
            this.passwordVerifyEnabled = false;
          }
        }).catch((err) => {
          this.passwordVerifyEnabled = false;
          console.error(err);
        }).finally(() => {
          this.switchLoading = false;
        });
      } else {
        this.passwordVerifyEnabled = true;
        this.sendVerifyCodeAndShowDialog();
      }
    },
    sendVerifyCodeAndShowDialog() {
      if (this.countdown > 0) return;
      sendSecurityVerifyCode().then(({ data: { data, error_code: errorCode } }) => {
        if (errorCode === 0) {
          this.mobileMask = data;
          this.showVerifyDialog = true;
          this.$message.success('验证码发送成功');
          this.countdown = 120;
          const timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(timer);
            }
          }, 1000);
        } else {
          this.passwordVerifyEnabled = false;
        }
      }).catch((err) => {
        this.passwordVerifyEnabled = false;
        console.error(err);
      });
    },
    sendVerifyCode() {
      if (this.countdown > 0) return;
      sendSecurityVerifyCode().then(({ data: { data, error_code: errorCode } }) => {
        if (errorCode === 0) {
          this.mobileMask = data;
          this.$message.success('验证码发送成功');
          this.countdown = 120;
          const timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(timer);
            }
          }, 1000);
        } else {
          console.error('验证码发送失败');
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    confirmVerify() {
      if (!this.verifyCode) {
        this.$message.warning('请输入验证码');
        return;
      }
      this.verifyLoading = true;
      const { merchantId } = this.loginInfo;
      checkSecurityVerifyCode({
        vertifyCode: this.verifyCode,
      }).then(({ data: { error_code: errorCode } }) => {
        if (errorCode === 0) {
          updateSecurityStatus({
            merchantId,
            status: 0,
          }).then(({ data: { error_code: updateCode } }) => {
            if (updateCode === 0) {
              this.verifyLoading = false;
              this.showVerifyDialog = false;
              this.passwordVerifyEnabled = false;
              this.verifyCode = '';
              this.$message.success('安全验证已关闭！');
            } else {
              this.verifyLoading = false;
              this.passwordVerifyEnabled = true;
            }
          }).catch((err) => {
            this.verifyLoading = false;
            this.passwordVerifyEnabled = true;
            console.error(err);
          });
        } else {
          this.verifyLoading = false;
          this.passwordVerifyEnabled = true;
        }
      }).catch((err) => {
        this.verifyLoading = false;
        this.passwordVerifyEnabled = true;
        console.error(err);
      });
    },
    handleVerifyDialogClose() {
      this.passwordVerifyEnabled = true;
      this.switchLoading = false;
      this.countdown = 0;
      this.verifyCode = '';
    },
    validateAmount(rule, value, callback) {
      if (!value || +value <= 0) {
        callback(new Error('请输入提现金额'));
      } else if (value > divide(this.withdrawalForm.canAmount, 100)) {
        callback(new Error(`最多可提现${divide(this.withdrawalForm.canAmount, 100)}元`));
      } else {
        callback();
      }
    },
    handlePasswordToggle(formName) {
      const form = this[formName];
      if (form.pwdType === 'password') {
        form.pwdType = 'text';
        form.pwdIcon = 'show-pwd';
      } else {
        form.pwdType = 'password';
        form.pwdIcon = 'hide-pwd';
      }
    },
    handleWithdrawalPasswordIconClick() {
      this.handlePasswordToggle('withdrawalForm');
    },
    handleDividePasswordIconClick() {
      this.handlePasswordToggle('divideForm');
    },
    goToWithdrawalRecords() {
      this.$router.push({
        path: '/cloud-manage/split-account/withdrawal-records',
        query: {
          withdrawalStatus: 1,
        },
      });
    },
    goToDivideAccounts() {
      this.$router.push({
        path: '/cloud-manage/split-account/divide-accounts',
        query: {
          splitStatus: 0,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page-container {
  height: calc(100vh - 50px - 60px);

  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .account-cards {
    display: flex;
    padding: 20px 50px;
    border-bottom: 20px solid #eee;

    .account-card {
      flex: 1;
      padding: 20px;
      margin-right: 20px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      &:last-child {
        margin-right: 0;
      }

      .card-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 25px;

        .title-text {
          display: flex;
          align-items: center;

          .el-icon-question {
            margin-left: 5px;
            font-size: 25px;
          }
        }

        .security-setting-btn {
          padding: 0;
          margin-left: auto;
          font-size: 16px;
          color: #409eff;
        }
      }

      .card-amount {
        margin: 15px 0;
        font-size: 18px;
        color: #606266;
      }

      .card-btns {
        margin-top: 10px;

        .btn {
          margin-right: 20px;
          color: #00b5ff;
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      // copilot begin
      .in-progress-counts {
        margin-top: 15px;

        .count-row {
          display: flex;
          align-items: stretch;
          justify-content: space-between;

          .count-item {
            flex: 1;
            cursor: pointer;

            &:first-child {
              margin-right: 10px;
            }

            &:hover {
              background-color: rgba(0, 0, 0, 0.03);
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
              opacity: 0.8;
            }

            .count-content {
              .count-label {
                font-size: 14px;
                color: #606266;
              }

              .count-value {
                margin-left: 10px;
                font-size: 16px;
                font-weight: bold;
              }
            }

            &.withdrawal {
              .count-value {
                color: #f56c6c;
              }
            }

            &.split-account {
              .count-value {
                color: #e6a23c;
              }
            }
          }
        }
      }

      // copilot end
    }
  }

  .top-account {
    padding: 20px 50px;
    font-size: 30px;
    border-bottom: 20px solid #eee;

    .btn {
      padding-left: 30px;
      color: #00b5ff;
      cursor: pointer;
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .search-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }
  }

  .tip-content {
    font-size: 16px;
    line-height: 24px;

    p:first-child {
      padding-bottom: 10px;
      font-weight: bold;
    }
  }

  .no-resister {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding-left: 130px;
    background-image: url(../../../assets/images/cloud-manage/bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    & > div {
      font-size: 72px;
      font-weight: 900;
      color: #141938;
    }

    & > p {
      width: 760px;
      margin-top: 40px;
      font-size: 20px;
      font-weight: 400;
      line-height: 40px;
      color: #455260;
    }

    /deep/ .el-button {
      width: 200px;
      height: 66px;
      margin-top: 75px;
      font-size: 24px;
      font-weight: 500;
      color: #fff;
      background: linear-gradient(90deg, #1f9eff, #027aff);
      box-shadow: 0 14px 43px 0 rgba(31, 158, 255, 0.22);
    }
  }

  .table-container {
    padding: 40px 50px 0;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }

  .detail-form-row {
    display: flex;
    align-items: center;

    span {
      margin-right: 10px;
    }
  }

  .detail-form-container {
    padding: 0 20px;

    /deep/ .el-form-item__label {
      color: #606266;
      text-align: left;
    }

    /deep/ .el-form-item__content {
      color: #333;
      text-align: right;
    }

    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
}

.security-dialog {
  padding: 20px;

  .security-item {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 10px 0;

    .security-label {
      font-size: 16px;
      font-weight: bold;
      color: #303133;
      white-space: nowrap;
    }

    .status-text {
      color: #606266;
    }

    .el-switch {
      margin: 0;
    }
  }
}

.verify-dialog {
  padding: 20px;

  .verify-tip {
    margin-bottom: 20px;
    font-size: 16px;
    color: #606266;
    text-align: left;

    .phone-mask {
      color: #409eff;
    }
  }

  .verify-input {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    .verify-label {
      margin-right: 10px;
      font-size: 16px;
      color: #606266;
      white-space: nowrap;
    }

    .verify-code-input {
      flex: 1;
    }
  }

  .verify-actions {
    text-align: center;
  }
}

.detail-section-title {
  position: relative;
  margin: 16px 0;

  &::before {
    position: absolute;
    top: -10px;
    left: 0;
    width: 100%;
    height: 1px;
    content: "";
    background-color: #e0e0e0;
  }
}

.copy-btn {
  margin-left: 8px;
}
</style>
